module.exports = __webpack_public_path__ + "img/shopping-basket-fill.65f12a80.svg";